import Snackbar from "src/base-components/Snackbar";
import ReminderToast from "src/components/ReminderToast";
import GlobalReminderModals from "src/components/GlobalReminderModals";
import Router from "./router";
import { useCallback, useEffect } from "react";
import { useAppSelector } from "./stores";
import { selectAuthUser } from "./stores/auth";
import { appInitializer } from "./helpers";
// import { usePushNotification } from "./firebase";
import runOneSignal, { usePushNotification } from "./onesignal";

const AppContent = () => {
  const pushNotification = usePushNotification();
  const authUser = useAppSelector(selectAuthUser);

  useEffect(() => {
    runOneSignal();
    pushNotification;
    appInitializer(authUser);
    // Expose a dev helper to trigger the reminder toast from console
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.showReminderToastForDebug = (payload: any) =>
        window.dispatchEvent(
          new CustomEvent("show-reminder-toast", { detail: payload })
        );
    } catch (err) {
      // ignore
    }
  }, []);

  const RouterCallback = useCallback(
    () => <Router />,
    [authUser?.role?.permissions?.length]
  );

  return (
    <>
      <Snackbar />
      <ReminderToast />
      <GlobalReminderModals />
      <RouterCallback />
    </>
  );
};
export default AppContent;
